module.exports = __webpack_public_path__ + "static/img/financijskekartice.944c16c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/financijskekartice.png
// module id = aCmK
// module chunks = 0